import React, { useState } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import CssBaseline from "@material-ui/core/CssBaseline";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import LockIcon from "@material-ui/icons/Lock";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import Avatar from "@material-ui/core/Avatar";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { useSelector, useDispatch } from 'react-redux';

//icons Regular
import FarChartArea from '../assets/svgs/regular/chart-area';
import FarCalendarAlt from '../assets/svgs/regular/calendar-alt';
import FarHouseUser from '../assets/svgs/regular/house-user';
import FarPuzzlePiece from '../assets/svgs/regular/puzzle-piece';
import FarTools from '../assets/svgs/regular/tools';
import FarUtensils from '../assets/svgs/regular/utensils';
import FarInfoCircle from "../assets/svgs/regular/info-circle";

//icons solid
import FasChartArea from '../assets/svgs/solid/chart-area';
import FasCalendarAlt from '../assets/svgs/solid/calendar-alt';
import FasHouseUser from '../assets/svgs/solid/house-user';
import FasPuzzlePiece from '../assets/svgs/solid/puzzle-piece';
import FasTools from '../assets/svgs/solid/tools';
import FasUtensils from '../assets/svgs/solid/utensils';
import FasInfoCircle from "../assets/svgs/solid/info-circle";

import { DashboardRoute } from "../routers/DashboardRoute";
import { NavLink, useHistory } from "react-router-dom";

//Material UI Components
import { Button, Hidden } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Modal from '@material-ui/core/Modal';


//////////////////////////////////
import { connect } from 'react-redux';
/////////////////////////////////

//material ui components
import Grid from '@material-ui/core/Grid';
import { WaitGetGetAllCommunities, WaitGetCommunityById } from '../actions/communityActions'
import Loader from './Loader';
import { UpdateCurrentLocation } from "../actions/currentUrlActions";

const drawerWidth = 100;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexGrow: 1
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    minHeight: 64,
    height: 64,
    boxShadow: "none",
    justifyContent: 'center'
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  hide: {
    display: "none",
  },
  show: {
    display: "block",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    background: "#1f1f1f",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      // width: theme.spacing(9) + 1,
      width: theme.spacing(11) + 8
    },
  },
  toolbar: {
    ...theme.mixins.toolbar,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: 36,
    position: 'absolute',
    height: '50%',
    width: '5%',
    cursor: 'pointer',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  managmentLabel: {
    fontSize: '17px',
    fontFamily: 'Gotham-Bold',
    marginLeft: '0.4em',
    color: '#a9a8a8',
    opacity: 1,
    transition: 'height 0ms 400ms, opacity 400ms 0ms',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  }
}));

const SideNav = (props) => {
  const d = useDispatch();

  const currentLocationObject = useSelector(state => state.currentUrlReducer.currentLocationData);
  const classes = useStyles();

  //Selectores
  const open = false;

  const [viewPort, setViewPort] = React.useState();
  const [communitiesDataState, setCommunitiesDataState] = React.useState(undefined);
  const [mobileOpen, setMobileOpen] = useState(false)

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  function handleResize() {
    const innerWidth = window ? window.innerWidth : 1024;
    const innerHeight = window ? window.innerHeight : 1024;

    setViewPort({
      width: innerWidth,
      height: innerHeight,
      size: innerWidth <= 1024 ? 'md' : innerWidth <= 800 ? 'sm' : innerWidth <= 600 ? 'xs' : 'lg',
      mobile: innerWidth <= 1024,
    })
  }

  React.useEffect(() => {
    window.addEventListener('resize', handleResize);

    GetCommunityData();

    return () => {
      window.removeEventListener('resize', handleResize);
    }
  }, [])

  let history = useHistory();

  const logout = () => {


    if (props.keyCloakData) {
      try {

        props.keyCloakData.logout();
        localStorage.clear();
      }
      catch (error) {
      }

      history.replace("/login");
    }

  }

  const communityIdinLocalStorage = (localStorage.getItem('communityId') && localStorage.getItem('communityId').length > 0) ? localStorage.getItem('communityId') : undefined;
  const communitySelected = (communityIdinLocalStorage && props && props.communityData && props.communityData.length > 0) ? props.communityData.find(comm => comm.communityId === communityIdinLocalStorage) : undefined;

  const worxHubActive = (
    communityIdinLocalStorage &&
    communitySelected &&
    communitySelected.worxHub &&
    communitySelected.worxHub.active &&
    communitySelected.worxHub.partnerId &&
    communitySelected.worxHub.partnerId.length > 0 &&
    communitySelected.worxHub.partnerKey &&
    communitySelected.worxHub.partnerKey.length > 0 &&
    communitySelected.worxHub.thwSite &&
    communitySelected.worxHub.thwSite.length > 0 &&
    communitySelected.worxHub.thwInstance &&
    communitySelected.worxHub.thwInstance.length > 0
  ) ? true : false;

  const telsActive = (
    communityIdinLocalStorage &&
    communitySelected &&
    communitySelected.tels &&
    communitySelected.tels.active &&
    communitySelected.tels.businessUnitId &&
    communitySelected.tels.businessUnitId.length > 0 &&
    communitySelected.tels.refreshToken &&
    communitySelected.tels.refreshToken.length > 0
  ) ? true : false;


  //#region HANDLERS
  const GetCommunityData = async () => {

    let communitiesData = undefined;

    if (localStorage.getItem('superAdmin') === "false") {
      communitiesData = await WaitGetCommunityById(localStorage.getItem('communityId'));
    } else {
      communitiesData = await WaitGetGetAllCommunities();
    }

    setCommunitiesDataState(communitiesData);
  }
  //#endregion

  //#region  INNER CONPONENTS
  //#region Banner
  const ImageComponent = () => {
    return (
      <Grid item container>
        <Grid item style={{ display: 'flex', alignItems: 'center' }}>
          <Grid
            item
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          ></Grid>
          <img
            style={(viewPort && viewPort.mobile) ? { width: '200px' } : { width: '200px' }}
            src={`/assets/images/Engage360-logo.png`}
            alt="logo"
            className="logo"
          />
        </Grid>
        <Grid item style={{ display: 'flex', alignItems: 'center' }}>
          <Grid className={classes.managmentLabel}>
            Management
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const AvatarComponent = () => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const menuOpen = Boolean(anchorEl);

    const handleMenu = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    return (
      <Grid item style={{ display: 'flex', alignItems: 'center' }}>

        <Avatar
          className="avatar-left mobile-content"
          src="https://engage360.s3.amazonaws.com/Residents/profile.png"
          onClick={handleMenu}
        >

        </Avatar>

        <Menu
          id="menu-appbar"
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={menuOpen}
          onClose={handleClose}
        >
          <MenuItem onClick={logout} button >
            <LockIcon className="btn-icon-nav text-medium" />{" "}
            <span className="text-medium">Sign out</span>
          </MenuItem>
        </Menu>

      </Grid>
    );
  };

  const BannerComponent = () => {
    return (
      <AppBar
        color="primary"
        position="fixed"
        className={clsx(classes.appBar, { [classes.appBarShift]: open })}
      >
        <Toolbar className="makeStyles-toolbar">
          <Grid container>
            {/* logo */}
            <Grid item container xs={3} style={{ display: 'flex', }}>
              <ImageComponent />
            </Grid>
            {/* header buttons  */}
            <Grid item container xs={8} key={'headerButtons'} justifyContent='flex-end' style={{ display: 'flex', alignItems: 'center' }}>
              {
                props.headerButtons ?
                  props.headerButtons
                  :
                  undefined
              }
            </Grid>
            {/* LOADING SCREEN  */}
            {
              props.isLoading.loading ?
                <Loader isLoading={props.isLoading} /> : ""
            }
            {/* avatar */}
            <Grid item container xs={1} justifyContent='flex-end' alignContent='center'>
              <AvatarComponent />
              {/* <Grid item style={{ }}>
                  <div>
                    <IconButton
                      aria-label="account of current user"
                      aria-controls="menu-appbar"
                      aria-haspopup="true"
                      onClick={handleMenu}
                      color="inherit"
                      className="menu-right"
                    >
                      <MoreVertIcon />
                    </IconButton>
                    <Menu
                      id="menu-appbar"
                      anchorEl={anchorEl}
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      keepMounted
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      open={menuOpen}
                      onClose={handleClose}
                    >
                      <MenuItem onClick={logout} button>
                        <LockIcon className="btn-icon-nav text-medium" />{" "}
                        <span className="text-medium">Sign out</span>
                      </MenuItem>
                    </Menu>
                  </div>
                </Grid> */}
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    );
  };

  //#region Drawer
  const DrawerComponent = () => {
    return (
      <div>
        <div className="makeStyles-toolbar-10">
          <IconButton></IconButton>
        </div>
        <Divider></Divider>
        <List id='SideNav_Menu' component="nav" className="primary">
          <div>
            {/* Dashboard */}
            <Card
              id='SideNav_Menu_Dashboard'
              button="true"
              className="primary"
              component={NavLink}
              activeClassName="active"
              to="/dashboard"
              onClick={() => {
                setTimeout(() => {

                  history.push('/')
                  history.push('/dashboard')
                }, 20);
              }}
            >
              <CardContent
                className="card-center-container"
              >


                <Grid item container alignContent="center" justifyContent="center">
                  <Grid item className="iconNavMenuSize">
                    {
                      (!currentLocationObject || (currentLocationObject && currentLocationObject.pathname === '/dashboard')) ?
                        <FasChartArea className="iconNavMenuSize selectedIcon" />
                        :
                        <FarChartArea className="iconNavMenuSize" />
                    }
                  </Grid>
                </Grid>
                <p className="drawer-title" style={{ marginLeft: '-8px', marginTop: '0' }}>Dashboard</p>
              </CardContent>
            </Card>
            {/* Dashboard */}
          </div>
          {/* {
          isSuperAdmin === true ?
        
        <div>
          <Card
              id='SideNav_Menu_Version'
              button="true"
              className="primary"
              component={NavLink}
              activeClassName="active"
              to="/version"
            >
              <CardContent className="card-center-container">
                <FontAwesomeIcon
                  className="icon-menu-size"
                  icon={faCodeBranch}
                />
                <p className="drawer-title-long">Version</p>
              </CardContent>
            </Card>
        </div>
        :
        undefined
      } */}
          <div >
            {/* Scheduler*/}
            <Card
              id='SideNav_Menu_Schedule'
              button="true"
              className="primary"
              component={NavLink}
              activeClassName="active"
              to="/scheduler"
              onClick={() => {
                d(UpdateCurrentLocation('true'));
              }}
            >
              <CardContent
                className="card-center-container"
              >
                <Grid item container alignContent="center" justifyContent="center">
                  <Grid item className="iconNavMenuSize">
                    {
                      (currentLocationObject && currentLocationObject.pathname === '/scheduler') ?
                        <FasCalendarAlt className="iconNavMenuSize selectedIcon" />
                        :
                        <FarCalendarAlt className="iconNavMenuSize" />
                    }
                  </Grid>
                </Grid>
                <p className="drawer-title" style={{ marginLeft: '-8px', marginTop: '0' }}>Schedule</p>
              </CardContent>
            </Card>
            {/* Scheduler */}
          </div>
          <div>
            {/* Activities */}
            <Card
              id='SideNav_Menu_Activities'
              button="true"
              className="primary"
              component={NavLink}
              activeClassName="active"
              to="/activities"
              onClick={() => {
                d(UpdateCurrentLocation('true'))
              }}
            >
              <CardContent
                className="card-center-container"
              >
                <Grid item container alignContent="center" justifyContent="center">
                  <Grid item className="iconNavMenuSize">
                    {
                      (currentLocationObject && currentLocationObject.pathname === '/activities') ?
                        <FasPuzzlePiece className="iconNavMenuSize selectedIcon" />
                        :
                        <FarPuzzlePiece className="iconNavMenuSize" />
                    }
                  </Grid>
                </Grid>
                <p className="drawer-title-long">Activities</p>
              </CardContent>
            </Card>
            {/* Activities */}
          </div>
          <div>
            {/* Dinning */}
            <Card
              id='SideNav_Menu_Dinning'
              className="primary"
              component={NavLink}
              activeClassName="active"
              to="/dinings"
              onClick={() => {
                d(UpdateCurrentLocation('true'))
              }}
            >
              <CardContent
                className="card-center-container"
              >
                <Grid item container alignContent="center" justifyContent="center">
                  <Grid item className="iconNavMenuSize">
                    {
                      (currentLocationObject && currentLocationObject.pathname === '/dinings') ?
                        <FasUtensils className="iconNavMenuSize selectedIcon" />
                        :
                        <FarUtensils className="iconNavMenuSize" />
                    }
                  </Grid>
                </Grid>
                <p className="drawer-title-short">Dining</p>
              </CardContent>
            </Card>
          </div>
          {
            (communitySelected && !worxHubActive && !telsActive) ?
              <div>
                {/* Repairs */}
                <Card
                  id='SideNav_Menu_Repairs'
                  className="primary"
                  component={NavLink}
                  activeClassName="active"
                  to="/repairs"
                  onClick={() => {
                    d(UpdateCurrentLocation('true'))
                  }}
                >
                  <CardContent
                    className="card-center-container"
                  >
                    <Grid item container alignContent="center" justifyContent="center">
                      <Grid item className="iconNavMenuSize">
                        {
                          (currentLocationObject && currentLocationObject.pathname === '/repairs') ?
                            <FasTools className="iconNavMenuSize selectedIcon" />
                            :
                            <FarTools className="iconNavMenuSize" />
                        }
                      </Grid>
                    </Grid>
                    <p className="drawer-title-long">Repairs</p>
                  </CardContent>
                </Card>
              </div>
              :
              undefined
          }

          <div>
            {/* Community */}
            <Card
              id='SideNav_Menu_Community'
              button="true"
              className="primary"
              component={NavLink}
              activeClassName="active"
              to="/community"
              onClick={() => {
                d(UpdateCurrentLocation('true'))
              }}
            >
              <CardContent
                className="card-center-container"
              >
                <Grid item container alignContent="center" justifyContent="center">
                  <Grid item className="iconNavMenuSize">
                    {
                      (currentLocationObject && currentLocationObject.pathname === '/community') ?
                        <FasHouseUser className="iconNavMenuSize selectedIcon" />
                        :
                        <FarHouseUser className="iconNavMenuSize" />
                    }
                  </Grid>
                </Grid>
                <p className="drawer-title" style={{ marginLeft: '-8px', marginTop: '0' }}>Community</p>
              </CardContent>
            </Card>
          </div>
          {/* Boards 
          <div>
            <Card
              id='SideNav_Menu_Boards'
              className="primary"
              component={NavLink}
              activeClassName="active"
              to="/boards"
              onClick={() => {
                d(UpdateCurrentLocation('true'))
              }}
            >
              <CardContent
                className="card-center-container"
              >
                <Grid item container alignContent="center" justifyContent="center">
                  <Grid item className="iconNavMenuSize">
                    {
                      (currentLocationObject && currentLocationObject.pathname === '/boards') ?
                        <FasThumbTack className="iconNavMenuSize selectedIcon" />
                        :
                        <FarThumbTack className="iconNavMenuSize" />
                    }
                  </Grid>
                </Grid>
                <p className="drawer-title-long">Info Board</p>
              </CardContent>
            </Card>
          </div>
        */}
          {/* HELP TILES */}
          {
            localStorage.getItem('superAdmin') === "true" ?
              <div>
                <Card
                  id='SideNav_Info_Circle'
                  button="true"
                  className="primary"
                  component={NavLink}
                  activeClassName="active"
                  to="/helptiles"
                  onClick={() => {
                    d(UpdateCurrentLocation('true'))
                  }}
                >
                  <CardContent className="card-center-container">
                    <Grid item container alignContent="center" justifyContent="center">
                      <Grid item className="iconNavMenuSize">
                        {
                          (currentLocationObject && currentLocationObject.pathname === '/helptiles') ?
                            <FasInfoCircle className="iconNavMenuSize selectedIcon" />
                            :
                            <FarInfoCircle className="iconNavMenuSize" />
                        }
                      </Grid>
                    </Grid>
                    <p className="drawer-title-long">Help Info</p>
                  </CardContent>
                </Card>
              </div>
              :
              undefined
          }
          <div>
            {/* Diagnostic Report */}
            <Card
              id='SideNav_Menu_DiagnosticReport'
              button="true"
              className="primary"
              component={NavLink}
              activeClassName="active"
              to="/diagnosticReport"
              onClick={() => {
                setTimeout(() => {

                  history.push('/')
                  history.push('/diagnosticReport')
                }, 20);
              }}
            >
              <CardContent
                className="card-center-container"
              >


                <Grid item container alignContent="center" justifyContent="center">
                  <Grid item className="iconNavMenuSize">
                    {
                      (!currentLocationObject || (currentLocationObject && currentLocationObject.pathname === '/diagnosticReport')) ?
                        <FasChartArea className="iconNavMenuSize selectedIcon" />
                        :
                        <FarChartArea className="iconNavMenuSize" />
                    }
                  </Grid>
                </Grid>
                <p className="drawer-title" style={{ marginLeft: '-8px', marginTop: '0' }}>Diagnostic</p>
              </CardContent>
            </Card>
            {/* Dashboard */}
          </div>
          {/* USERS */}
          {/* {
            isSuperAdmin === true ?
            <div>
            <Card
                id='SideNav_Menu_Users'
                button="true"
                className="primary"
                component={NavLink}
                activeClassName="active"
                to="/users"
              >
                <CardContent className="card-center-container">
                  <FontAwesomeIcon
                    className="icon-menu-size"
                    icon={faUsers}
                  />
                  <p className="drawer-title">Users</p>
                </CardContent>
              </Card>
            </div>
            :
            undefined
          } */}
        </List>
      </div>
    );
  };
  //#endregion

  //#region RedirectModalComponent
  const RedirectModalComponent = () => {

    const styles = {
      paperModal: {
        backgroundColor: '#1F1F1F',
        padding: '6px',
        height: '75%',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        width: '45%',

      },
      content: {
        padding: '10px',
        height: '80%'
      },
      text: {
        height: '20%',
      }
    };

    return (
      <Modal
        open={true}
        onClose={() => logout()}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Paper className='modalPaperStyles' elevation={3} style={{ ...styles.paperModal }} color='secondary'>
          <Grid container justifyContent='center' style={{ height: '100%', fontSize: '12px' }}>
            <Grid item container justifyContent='center' style={{ ...styles.content, height: '85%', overflow: 'auto' }}>
              <Grid item container justifyContent='flex-start' className='titleResidentModal' style={{ ...styles.text }} >
                <Grid item>
                  Login failed
                </Grid>
              </Grid>
              <Grid item container className='subtitleDashboard' justifyContent='center' alignContent='center' style={{ ...styles.content }}>
                <Grid item container justifyContent='center' style={{ height: '60%' }}>
                  <Grid item container justifyContent='center'>
                    <Grid item>
                      <img alt="Error" src='https://engage360.s3.amazonaws.com/Icons/Alerts/error-circle.png' style={{ height: '150px', widt: '150px' }}></img>
                    </Grid>
                  </Grid>
                  <Grid item container justifyContent='center'>
                    <Grid item>
                      <p>This user has no longer access to the community</p>
                      <p>closing this windows will redirect to the login page</p>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item container justifyContent='center' alignItems='flex-end' style={{ height: '15%', }}>
              <Grid item xs={3}>
                <Button className='buttonBlue' onClick={() => logout()}>Close</Button>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Modal>
    );
  }
  //#endregion
  //#endregion
  return (
    <div className={classes.root} style={{ position: 'relative' }}>
      <CssBaseline />
      <BannerComponent />

      <Hidden mdUp implementation="css">
        <Drawer
          // container={container}
          variant="temporary"
          open={mobileOpen}
          className={classes.drawer}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          classes={{
            paper: classes.drawerPaper,
          }}
        // ModalProps={{
        //   keepMounted: true, // Better open performance on mobile.
        // }}
        >

          <DrawerComponent />
        </Drawer>
      </Hidden>

      <Hidden smDown implementation="css">
        <Drawer
          className={classes.drawer}
          classes={{
            paper: classes.drawerPaper,
          }}
          variant="permanent"
          open
          anchor="left"
        >
          <DrawerComponent />
        </Drawer>
      </Hidden>

      <main className={classes.content}>
        {/* className="makeStyles-toolbar-10"  */}
        <div className={classes.toolbar} />
        {
          communitiesDataState && Array.isArray(communitiesDataState) && communitiesDataState.length > 0 ?
            <DashboardRoute worxHubActive={worxHubActive} />
            :
            communitiesDataState && Array.isArray(communitiesDataState) && communitiesDataState.length === 0 ?
              <RedirectModalComponent />
              :
              undefined
        }
      </main>
    </div>
  );
};




function mapStateToProps(state) {

  const communityData = (state.communityReducer && state.communityReducer.communityData && Array.isArray(state.communityReducer.communityData) && state.communityReducer.communityData.length > 0) ? state.communityReducer.communityData.map(item => ({ _id: item._id, name: item.communityName, communityId: item.communityId, worxHub: item.worxHub, tels: item.tels })) : [];
  const keyCloakData = (state.keyCloakReducer && state.keyCloakReducer.keyCloakData) ? state.keyCloakReducer.keyCloakData : undefined;
  const headerButtons = (state.headerButtonsReducer && state.headerButtonsReducer.headerButtonsData) ? state.headerButtonsReducer.headerButtonsData : undefined;

  let loadingScreen = {
    loading: false
  }

  // We get the reducer that is loading data
  const loadingReducer = Object.entries(state)
    .filter(key => {
      if (key[1].loading)
        return key;
      return null
    });

  if (loadingReducer.length > 0)
    loadingScreen = loadingReducer[0][1];

  return {
    keyCloakData: keyCloakData,
    communityData: communityData,
    headerButtons: headerButtons,
    isLoading: loadingScreen
  }
};


export default connect(mapStateToProps)(SideNav); 
